;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { MouseEvent } from "react"
import MUITablePagination from "@mui/material/TablePagination"

type TablePaginationProps = {
  totalCount: number
  pageSize: number
  page: number
  onPageChange: (event: MouseEvent<HTMLButtonElement> | null, page: number) => void
}

export default function TablePagination({
  totalCount,
  pageSize,
  page,
  onPageChange,
}: TablePaginationProps) {
  return totalCount > pageSize ? (
    <MUITablePagination
      rowsPerPageOptions={[-1]}
      count={totalCount}
      rowsPerPage={pageSize}
      page={page}
      slotProps={{
        select: {
          inputProps: {
            "aria-label": "rows per page",
          },
          native: true,
        },
      }}
      component="div"
      onPageChange={onPageChange}
    />
  ) : (
    <></>
  )
}
